module.exports = __webpack_public_path__ + "media/icons/mail@3x-c64623a6.svg";